import { CommonModule } from '@angular/common';
import { Component, Renderer2, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { FeatureFlagsService } from '../../../services';
import {
  DownloadService,
  PromotionalDialogConfig,
  PromotionalDialogService,
} from '../../services';
import { ExportHelpers } from '../../services/export-helper/export-helper.service';

@Component({
  selector: 'phoenix-promotional-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  templateUrl: './promotional-dialog.component.html',
  styles: [
    `
      .promotional-dialog {
        &__container {
          animation: slideIn 0.5s ease-out;
        }

        &__item {
          overflow: hidden;

          &--leave {
            opacity: 0;
            height: 0;
            transition:
              opacity 100ms ease-in,
              height 500ms ease-in;
          }
        }

        @keyframes slideIn {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      }
    `,
  ],
})
export class PromotionalDialogComponent {
  featureFlagsService = inject(FeatureFlagsService);
  downloadService = inject(DownloadService);
  dialogService = inject(PromotionalDialogService);
  renderer = inject(Renderer2);
  dialogs$ = this.dialogService.dialogs$;

  areAllDialogsHidden() {
    return this.dialogService.areAllDialogsHidden();
  }

  closeDialog(storageKey: string): void {
    this.dialogService.closeDialog(storageKey);
  }

  download(data: PromotionalDialogConfig) {
    if (data.downloadURL) {
      ExportHelpers.downloadLink(this.renderer, data.downloadURL);
    } else if (data.downloadManagementId) {
      this.downloadService.downloadElement(
        data.downloadManagementId,
        this.renderer
      );
    }
  }

  getVisibleDialogs(dialogs: any[] | null) {
    return dialogs?.filter((dialog: any) => dialog.isVisible).length ?? 0;
  }
}
